import { scoreOversold, scoreDca } from "./score"

// Ranking local (preco medio e sobrevenda): nao simula a carteira, calcula
// direto do RSI, do MACD e da distancia ate o preco medio. Extraido para que a
// 🧬 e o Optimizer usem a MESMA regua — duas copias divergiriam com o tempo.
export function rankingLocal(ativos, rsiData, goal, stats) {
  const out = []
  for (const p of ativos) {
    if (!p.currentPrice) continue
    const techD = rsiData[p.symbol] || {}
    const rsiRaw = parseFloat(techD?.rsi)
    const rsi = (!isNaN(rsiRaw) && rsiRaw > 0) ? rsiRaw : 50
    const macdSignal = techD?.macd || null
    const invested2 = (p.quantity||0) * parseFloat(p.avg_price||0)
    const val2 = (p.quantity||0) * parseFloat(p.currentPrice||0)
    const pct2 = invested2 > 0 ? (invested2 - val2) / invested2 * 100 : 0
    let score = 0
    // Era copia da formula do scoreDca, e copia e exatamente
    // o problema que o comentario dele descreve: a tela e o
    // registro divergiam. Um teste provou que as duas
    // concordavam ANTES desta troca, em quatro casos.
    if (goal === "dca") score = scoreDca(pct2, rsi) ?? 0
    else if (goal === "oversold") score = scoreOversold(rsi, macdSignal) ?? 0
    const sh = stats?.sharpe_ratio || 0
    const avgP2 = parseFloat(p.avg_price)||0
    const curP2 = parseFloat(p.currentPrice)||0
    const dcaImp = avgP2 > curP2 ? ((avgP2-curP2)/avgP2*100) : 0
    out.push({symbol: p.symbol, score: Math.round(Math.min(100, Math.max(0, score))), sharpe: parseFloat(sh), mc: parseFloat(stats?.monte_carlo?.prob_positive||0), rsi: rsi.toFixed ? rsi.toFixed(1) : String(rsi), dcaImprove: dcaImp.toFixed(1), macd: macdSignal})
  }
  return out.sort((a,b) => b.score - a.score)
}
